const SIDEBAR_CLOSED_WIDTH = 175;
const SIDEBAR_OPENED_WIDTH = 324;

export { SIDEBAR_OPENED_WIDTH, SIDEBAR_CLOSED_WIDTH };
